import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useRef
} from "react";
import useUndoRedo from "../../hooks/useUndoRedo";
import { toast } from "react-toastify";
import "react-flow-renderer/dist/style.css";
import "./mobile-styles.css";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {
  Paper,
  Button,
  IconButton,
  List,
  ListItem,
  Typography,
  Box,
  Grid,
  Collapse,
  useMediaQuery,
  Fab,
  Slide,
  ClickAwayListener,
  Tooltip
} from "@material-ui/core";
import {
  Menu as MenuIcon,
  Close as CloseIcon,
  Add as AddIcon,
  ExpandLess,
  ExpandMore,
  Save as SaveIcon,
  ZoomIn as ZoomInIcon,
  ZoomOut as ZoomOutIcon,
  ChevronLeft,
  ChevronRight,
  Info,
  WhatsApp,
  AssignmentTurnedInOutlined
} from "@material-ui/icons";
import WebAssetIcon from '@material-ui/icons/WebAsset';


// import MainHeader from "../../components/MainHeader";
import { AuthContext } from "../../context/Auth/AuthContext";
import Title from "../../components/Title";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";



import ReactFlow, {
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  addEdge,
  useReactFlow,
  ReactFlowProvider,
  ConnectionLineType,
  updateEdge,
  applyNodeChanges,
  applyEdgeChanges
} from "react-flow-renderer";

import {
  ViewWeek,
  PersonAddAlt1
} from "@mui/icons-material";

// Imports dos nós (mantendo os mesmos)
import messageNode from "./nodes/messageNode.js";
import kanbanNode from "./nodes/kanbanNode";
import startNode from "./nodes/startNode";
import openaiNode from "./nodes/openaiNode";
import remarketingNode from "./nodes/remarketingNode";
import { validateInfiniteLoops } from "./validateLoops"; // [ANTIGRAVITY] Infinite Loop Guard
import { generateNodeName } from "./nodeUtils"; // [ANTIGRAVITY] Auto-Naming
//import conditionNode from "./nodes/conditionNode";
import intervalNode from "./nodes/intervalNode";
import imgNode from "./nodes/imgNode";
import jumpNode from "./nodes/jumpNode";
import docNode from "./nodes/docNode";
import randomizerNode from "./nodes/randomizerNode";
import videoNode from "./nodes/videoNode";
import switchFlowNode from "./nodes/switchFlowNode";
import attendantNode from "./nodes/attendantNode";
import RemoveEdge from "./nodes/removeEdge";
import audioNode from "./nodes/audioNode";
import { useNodeStorage } from "../../stores/useNodeStorage";
import singleBlockNode from "./nodes/singleBlockNode"; // Force Rebuild 001
import ticketNode from "./nodes/ticketNode";
import tagNode from "./nodes/tagNode";
import conditionCompareNode from "./nodes/conditionCompareNode";
import HttpRequestNode from "./nodes/httpRequestNode";
import removeTagNode from "./nodes/removeTagNode";
import VariableNode, {
  getFlowVariable,
  setFlowVariable,
} from "./nodes/variableNode";
import RegexNode from "./nodes/regexNode";
import inputNode from "./nodes/inputNode";
import schedulingNode from "./nodes/schedulingNode";
import buttonNode from "./nodes/buttonNode"; // [Plan 904] Meta API — Botones Interactivos
import carouselNode from "./nodes/carouselNode";
import FlowBuilderCarouselModal from "./nodes/FlowBuilderCarouselModal";
import listNode from "./nodes/listNode";     // [Plan 904] Meta API — Lista Interactiva
import pollNode from "./nodes/pollNode";     // Poll Node

// Imports dos modais (mantendo os mesmos)
import FlowBuilderAddImgModal from "../../components/FlowBuilderAddImgModal";
import FlowBuilderAddDocModal from "../../components/FlowBuilderAddDocModal";
import FlowBuilderTicketModal from "../../components/FlowBuilderAddTicketModal";
import FlowBuilderAddAudioModal from "../../components/FlowBuilderAddAudioModal";
import FlowBuilderAddTagModal from "../../components/FlowBuilderAddTagModal";
import FlowBuilderAddKanbanModal from "../../components/FlowBuilderAddKanbanModal";
import FlowBuilderRandomizerModal from "../../components/FlowBuilderRandomizerModal";
import FlowBuilderAddVideoModal from "../../components/FlowBuilderAddVideoModal";
import FlowBuilderSingleBlockModal from "../../components/FlowBuilderSingleBlockModal";
import FlowBuilderAddTextModal from "../../components/FlowBuilderAddTextModal";
import FlowBuilderAddJumpModal from "../../components/FlowBuilderAddJumpModal"; // IMPORTE DO MODAL JUMP
import FlowBuilderIntervalModal from "../../components/FlowBuilderIntervalModal";
//import FlowBuilderConditionModal from "../../components/FlowBuilderConditionModal";
import FlowBuilderMenuModal from "../../components/FlowBuilderMenuModal";
import FlowBuilderAddSwitchFlowModal from "../../components/FlowBuilderAddSwitchFlowModal";
import FlowBuilderAddAttendantModal from "../../components/FlowBuilderAddAttendantModal";
import FlowBuilderInputModal from "../../components/FlowBuilderInputModal";
import FlowBuilderConditionCompareModal from "../../components/FlowBuilderConditionCompareModal";
import FlowBuilderRemoveTagModal from "../../components/FlowBuilderRemoveTagModal";
import FlowBuilderOpenAIModal from "../../components/FlowBuilderAddOpenAIModal";
import FlowBuilderRemarketingModal from "../../components/FlowBuilderRemarketingModal";
// import FlowBuilderGeminiModal from "../../components/FlowBuilderGeminiModal";
import FlowBuilderAddPaymentValidationModal from "../../components/FlowBuilderAddPaymentValidationModal";
import paymentValidationNode from "./nodes/paymentValidationNode";
import FlowBuilderAddSchedulingModal from "../../components/FlowBuilderAddSchedulingModal";
import FlowBuilderInteractiveButtonModal from "./nodes/FlowBuilderInteractiveButtonModal"; // [Plan 904]
import FlowBuilderInteractiveListModal from "./nodes/FlowBuilderInteractiveListModal";     // [Plan 904]
import FlowBuilderPollModal from "../../components/FlowBuilderPollModal";

// Nuevos Nodos y Modales
import formNode from "./nodes/formNode";
import notifierNode from "./nodes/notifierNode";
import retargetingNode from "./nodes/retargetingNode";
import saveContactNode from "./nodes/saveContactNode";
import listMatchNode from "./nodes/listMatchNode"; // [Fuzzy Search]
import ticketStatusNode from "./nodes/ticketStatusNode"; // [ANTIGRAVITY] New node
import FlowBuilderAddFormModal from "../../components/FlowBuilderAddFormModal";
import FlowBuilderAddNotifierModal from "../../components/FlowBuilderAddNotifierModal";
import FlowBuilderAddRetargetingModal from "../../components/FlowBuilderAddRetargetingModal";
import FlowBuilderSaveContactModal from "../../components/FlowBuilderSaveContactModal";
import { ModalAddTicketStatus } from "./components/ModalAddTicketStatus"; // [ANTIGRAVITY] New modal

import { useParams, useHistory } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";
import ConfirmationModal from "../../components/ConfirmationModal";
import AIKnowledgeModal from "../../components/AIKnowledgeModal";
import AiSimulatorPanel from "./AiSimulatorPanel"; // [ANTIGRAVITY] Plan 899 — AI Simulator


import {
  TbRocket,
  TbMessage,
  TbClock,
  TbPhoto,
  TbMicrophone,
  TbArrowsRandom,
  TbVideo,
  TbUser,
  TbTicket,
  TbFile,
  TbTag,
  TbTagOff,
  TbArrowForwardUp,
  TbWorld,
  TbVariable,
  TbRegex,
  TbForms,
  TbGitBranch,
  TbSettingsAutomation,
  TbRobot,
  TbCash,
  TbCalendar,
  TbDeviceMobile,
  TbListDetails,
  TbWritingSign,
  TbBellRinging,
  TbClockPlay,
  TbSearch
} from "react-icons/tb";


const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    overflow: "hidden",
    backgroundColor: theme.palette.background.default
  },
  header: {
    flexShrink: 0,
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider} `
  },
  content: {
    flex: 1,
    display: "flex",
    position: "relative",
    overflow: "hidden"
  },
  // Sidebar colapsável para desktop
  sidebar: {
    width: props => props.sidebarOpen ? 300 : 60,
    backgroundColor: theme.palette.background.paper,
    borderRight: `1px solid ${theme.palette.divider} `,
    transition: "width 0.3s ease",
    display: "flex",
    flexDirection: "column",
    zIndex: 1000,
    [theme.breakpoints.down('md')]: {
      display: "none" // Ocultar sidebar em mobile
    }
  },
  sidebarHeader: {
    padding: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.divider} `,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: 56,
    backgroundColor: theme.palette.background.paper
  },
  sidebarContent: {
    flex: 1,
    overflowY: "auto",
    backgroundColor: theme.palette.background.paper,
    ...theme.scrollbarStyles
  },
  flowContainer: {
    flex: 1,
    position: "relative",
    backgroundColor: theme.palette.type === 'dark' ? '#121212' : '#F8F9FA',
    '& .react-flow__controls': {
      zIndex: 1100, // Garantir que fique acima de outros elementos
      bottom: theme.spacing(2),
      left: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        display: 'none' // Ocultar em mobile já que temos controles customizados
      }
    }
  },
  // Bottom sheet para mobile
  bottomSheet: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.palette.background.paper,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    boxShadow: theme.shadows[8],
    zIndex: 1500,
    maxHeight: "80vh",
    display: "flex",
    flexDirection: "column",
    border: `1px solid ${theme.palette.divider} `,
    [theme.breakpoints.up('lg')]: {
      display: "none" // Ocultar em desktop
    }
  },
  bottomSheetHandle: {
    width: 40,
    height: 4,
    backgroundColor: theme.palette.divider,
    borderRadius: 2,
    margin: "8px auto",
    cursor: "pointer"
  },
  bottomSheetHeader: {
    padding: theme.spacing(1, 2),
    borderBottom: `1px solid ${theme.palette.divider} `,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: theme.palette.background.paper
  },
  bottomSheetContent: {
    flex: 1,
    overflowY: "auto",
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    ...theme.scrollbarStyles
  },
  // Floating Action Button
  fab: {
    position: "fixed",
    top: 60, // Posicionar no topo, acima dos quickActions
    right: theme.spacing(2),
    zIndex: 1400,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
    [theme.breakpoints.down('md')]: {
      bottom: theme.spacing(9),
      top: 'auto'
    }
  },
  addFab: {
    position: "fixed",
    bottom: theme.spacing(2),
    left: theme.spacing(2),
    zIndex: 1400,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
    [theme.breakpoints.up('lg')]: {
      display: "none"
    }
  },
  // Categorias de nós
  categoryButton: {
    margin: theme.spacing(0.5),
    textTransform: "none",
    borderRadius: theme.spacing(1),
    minWidth: "auto",
    fontSize: "0.75rem",
    color: theme.palette.text.primary,
    borderColor: theme.palette.divider
  },
  nodeButton: {
    justifyContent: "flex-start",
    textTransform: "none",
    padding: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    borderRadius: theme.spacing(1),
    transition: "all 0.2s ease",
    color: theme.palette.text.primary,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      transform: "translateX(4px)"
    }
  },
  collapsedNodeButton: {
    width: 48,
    height: 48,
    minWidth: 48,
    padding: 0,
    margin: theme.spacing(0.5, 0.5),
    justifyContent: "center",
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    }
  },
  categoryHeader: {
    padding: theme.spacing(1),
    backgroundColor: theme.palette.action.hover,
    fontWeight: "bold",
    color: theme.palette.text.primary,
    cursor: "pointer",
    userSelect: "none",
    '&:hover': {
      backgroundColor: theme.palette.action.selected,
    }
  },
  quickActions: {
    position: "fixed",
    top: 120,
    right: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    zIndex: 1200,
    [theme.breakpoints.down('md')]: {
      display: "none"
    }
  },
  quickActionButton: {
    backgroundColor: theme.palette.background.paper,
    backdropFilter: "blur(10px)",
    boxShadow: theme.shadows[3],
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.divider} `,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      transform: "scale(1.05)",
      boxShadow: theme.shadows[6]
    }
  },
  // Mobile controls
  mobileControls: {
    position: "fixed",
    bottom: 80,
    left: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    zIndex: 1300,
    [theme.breakpoints.up('lg')]: {
      display: "none"
    }
  },
  controlButton: {
    backgroundColor: theme.palette.background.paper,
    backdropFilter: "blur(10px)",
    boxShadow: theme.shadows[3],
    width: 48,
    height: 48,
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.divider} `,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      transform: "scale(1.05)"
    }
  },
  categoryCard: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    border: `1px solid ${theme.palette.divider} `,
    marginBottom: theme.spacing(1)
  },
  categoryTitle: {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    color: theme.palette.text.primary
  },
  categoryNodeBtn: {
    width: "100%",
    marginBottom: theme.spacing(0.5),
    justifyContent: "flex-start",
    textTransform: "none",
    fontSize: "0.8rem",
    padding: theme.spacing(1, 1.5),
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    }
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "70vh",
    backgroundColor: theme.palette.background.paper
  }
}));



// Função para gerar string aleatória (mantida igual)
function geraStringAleatoria(tamanho) {
  var stringAleatoria = "";
  var caracteres =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < tamanho; i++) {
    stringAleatoria += caracteres.charAt(
      Math.floor(Math.random() * caracteres.length)
    );
  }
  return stringAleatoria;
}

// Tipos de nós (mantido igual)
const nodeTypes = {
  paymentValidation: paymentValidationNode,
  message: messageNode,
  start: startNode,
  //condition: conditionNode,
  interval: intervalNode,
  img: imgNode,
  doc: docNode,
  audio: audioNode,
  randomizer: randomizerNode,
  video: videoNode,
  singleBlock: singleBlockNode,
  ticket: ticketNode,
  tag: tagNode,
  kanban: kanbanNode,
  removeTag: removeTagNode,
  switchFlow: switchFlowNode,
  attendant: attendantNode,
  ticketStatus: ticketStatusNode, // [ANTIGRAVITY] New node
  httpRequest: HttpRequestNode,
  variable: VariableNode,
  regex: RegexNode,
  openai: openaiNode,
  remarketing: remarketingNode,
  input: inputNode,
  conditionCompare: conditionCompareNode,
  jump: jumpNode, // REGISTRO DO TIPO JUMP
  scheduling: schedulingNode,
  buttonInteractive: buttonNode,
  carouselInteractive: carouselNode,
  listInteractive: listNode,      // [Plan 904] Meta API — Lista Interactiva
  poll: pollNode,
  form: formNode,
  notifier: notifierNode,
  retargeting: retargetingNode,
  saveContact: saveContactNode,
  listMatch: listMatchNode
};

const edgeTypes = {
  buttonedge: RemoveEdge
};

const initialNodes = [
  {
    id: "1",
    position: { x: 250, y: 100 },
    data: { label: "Inicio do fluxo" },
    type: "start"
  }
];

const initialEdges = [];

// Função para detectar se é mobile
const isMobileDevice = () => {
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    ) ||
    ('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0)
  );
};

// Componente de controles customizados para mobile
const MobileControls = () => {
  const classes = useStyles();
  const { zoomIn, zoomOut, fitView } = useReactFlow();

  return (
    <div className={classes.mobileControls}>
      <IconButton
        onClick={() => zoomIn()}
        className={classes.controlButton}
        size="small"
      >
        <ZoomInIcon />
      </IconButton>

      <IconButton
        onClick={() => zoomOut()}
        className={classes.controlButton}
        size="small"
      >
        <ZoomOutIcon />
      </IconButton>

      <IconButton
        onClick={() => fitView({ padding: 0.2 })}
        className={classes.controlButton}
        size="small"
      >
        <WebAssetIcon />
      </IconButton>
    </div>
  );
};





const FlowBuilder = ({ id }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { user } = useContext(AuthContext);

  // Estados para interface
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);
  const [bottomSheetOpen, setBottomSheetOpen] = useState(false);
  const [expandedCategories, setExpandedCategories] = useState([]);
  const [flowName, setFlowName] = useState("");

  const classes = useStyles({ sidebarOpen });

  const [modalAddKanban, setModalAddKanban] = useState(null);





  // ... (existing imports)

  // Definição das categorias de nós (MOVIDO PARA DENTRO DO COMPONENTE)
  const nodeCategories = React.useMemo(() => [
    {
      name: i18n.t("flowBuilder.editor.categories.basics"),
      color: "#2979FF", // Bright Blue
      icon: <TbRocket size={24} />,
      nodes: [
        {
          icon: <TbRocket size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.start.name"),
          type: "start",
          description: i18n.t("flowBuilder.editor.nodes.start.description")
        }
      ]
    },
    {
      name: i18n.t("flowBuilder.editor.categories.content"),
      color: "#00E676", // Neon Green
      icon: <TbPhoto size={24} />,
      nodes: [
        {
          icon: <TbPhoto size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.content.name"),
          type: "singleBlock",
          description: i18n.t("flowBuilder.editor.nodes.content.description")
        },
        {
          icon: <TbMessage size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.text.name"),
          type: "message",
          description: i18n.t("flowBuilder.editor.nodes.text.description")
        },
        {
          icon: <TbVideo size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.video.name"),
          type: "video",
          description: i18n.t("flowBuilder.editor.nodes.video.description")
        },
        {
          icon: <TbPhoto size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.image.name"),
          type: "img",
          description: i18n.t("flowBuilder.editor.nodes.image.description")
        },
        {
          icon: <TbFile size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.doc.name"),
          type: "doc",
          description: i18n.t("flowBuilder.editor.nodes.doc.description")
        },
        {
          icon: <TbMicrophone size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.audio.name"),
          type: "audio",
          description: i18n.t("flowBuilder.editor.nodes.audio.description")
        }
      ]
    },
    {
      name: i18n.t("flowBuilder.editor.categories.interaction"),
      color: "#FFC400", // Neon Amber
      icon: <TbForms size={24} />,
      nodes: [
        /*
        {
    icon: <TbList size={24} />,
  name: i18n.t("flowBuilder.editor.nodes.menu.name"),
  type: "menu",
  description: i18n.t("flowBuilder.editor.nodes.menu.description")
        },
  */
        {
          icon: <TbForms size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.input.name"),
          type: "input",
          description: i18n.t("flowBuilder.editor.nodes.input.description")
        },
        {
          icon: <TbClock size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.interval.name"),
          type: "interval",
          description: i18n.t("flowBuilder.editor.nodes.interval.description")
        },
        {
          icon: <TbWritingSign size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.form.name") || "Formulario Web",
          type: "form",
          description: i18n.t("flowBuilder.editor.nodes.form.description") || "Envía un enlace para recolectar datos en un formulario web dinámico"
        }
      ]
    },
    {
      name: i18n.t("flowBuilder.editor.categories.logic"),
      color: "#D500F9", // Neon Purple
      icon: <TbGitBranch size={24} />,
      nodes: [
        {
          icon: <TbArrowsRandom size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.random.name"),
          type: "randomizer",
          description: i18n.t("flowBuilder.editor.nodes.random.description")
        },
        {
          icon: <TbGitBranch size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.condition.name") || "Condición (IF)",
          type: "conditionCompare",
          description: i18n.t("flowBuilder.editor.nodes.condition.description") || "Evalúa una condición"
        },
        {
          icon: <TbSearch size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.listMatch.name") || "Búsqueda en Lista",
          type: "listMatch",
          description: i18n.t("flowBuilder.editor.nodes.listMatch.description") || "Búsqueda inteligente en listas"
        },
        {
          icon: <TbArrowForwardUp size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.jump.name") || "Saltar",
          type: "jump",
          description: i18n.t("flowBuilder.editor.nodes.jump.description") || "Salta a otro bloque del flujo"
        }
      ]
    },
    {
      name: i18n.t("flowBuilder.editor.categories.system"),
      color: "#FF5A00", // Neon Orange
      icon: <TbSettingsAutomation size={24} />,
      nodes: [
        {
          icon: <TbTicket size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.ticket.name"),
          type: "ticket",
          description: i18n.t("flowBuilder.editor.nodes.ticket.description")
        },
        {
          icon: <TbTag size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.tag.name"),
          type: "tag",
          description: i18n.t("flowBuilder.editor.nodes.tag.description")
        },
        {
          icon: <TbTagOff size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.removeTag.name"),
          type: "removeTag",
          description: i18n.t("flowBuilder.editor.nodes.removeTag.description")
        },
        {
          icon: <PersonAddAlt1 size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.saveContact.name") || "Guardar Contacto",
          type: "saveContact",
          description: i18n.t("flowBuilder.editor.nodes.saveContact.description") || "Actualiza los datos del contacto con variables de flujo"
        },
        {
          icon: <TbArrowForwardUp size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.switchFlow.name"),
          type: "switchFlow",
          description: i18n.t("flowBuilder.editor.nodes.switchFlow.description")
        },
        {
          icon: <TbUser size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.attendant.name"),
          type: "attendant",
          description: i18n.t("flowBuilder.editor.nodes.attendant.description")
        },
        {
          icon: <ViewWeek size={24} />,
          name: i18n.t("flowBuilder.kanban.name"),
          type: "kanban",
          description: i18n.t("flowBuilder.kanban.description")
        },
        {
          icon: <AssignmentTurnedInOutlined size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.ticketStatus.name") || "Estado de Ticket",
          type: "ticketStatus",
          description: i18n.t("flowBuilder.editor.nodes.ticketStatus.description") || "Cambiar el estado actual del ticket"
        }
      ]
    },
    {
      name: i18n.t("flowBuilder.editor.categories.integrations"),
      color: "#06B6D4", // Cyan
      icon: <TbWorld size={24} />,
      nodes: [
        {
          icon: <TbWorld size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.httpRequest.name"),
          type: "httpRequest",
          description: i18n.t("flowBuilder.editor.nodes.httpRequest.description")
        },
        {
          icon: <TbVariable size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.variable.name"),
          type: "variable",
          description: i18n.t("flowBuilder.editor.nodes.variable.description")
        },
        {
          icon: <TbRegex size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.regex.name"),
          type: "regex",
          description: i18n.t("flowBuilder.editor.nodes.regex.description")
        },
        {
          icon: <TbRobot size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.openai.name"),
          type: "openai",
          description: i18n.t("flowBuilder.editor.nodes.openai.description")
        },

        {
          icon: <TbCash size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.paymentValidation.name") || "Reconocimiento Pago",
          type: "paymentValidation",
          description: i18n.t("flowBuilder.editor.nodes.paymentValidation.description") || "Detecta y valida comprobantes de pago con IA"
        },
        {
          icon: <TbCalendar size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.scheduling.name") || "Agendamiento",
          type: "scheduling",
          description: i18n.t("flowBuilder.editor.nodes.scheduling.description") || "Gestionar citas y horarios"
        },
        {
          icon: <TbBellRinging size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.notifier.name") || "Notificador WhatsApp",
          type: "notifier",
          description: i18n.t("flowBuilder.editor.nodes.notifier.description") || "Envía una notificación silenciosa a otro número de WhatsApp"
        },
        {
          icon: <TbClockPlay size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.retargeting.name") || "Retargeting",
          type: "retargeting",
          description: i18n.t("flowBuilder.editor.nodes.retargeting.description") || "Programa envíos futuros condicionados o inmortales"
        },
        {
          icon: <TbClock size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.remarketing.name") || "Remarketing",
          type: "remarketing",
          description: i18n.t("flowBuilder.editor.nodes.remarketing.description") || "Pausa el flujo y agenda acciones de remarketing. Retoma si el usuario responde."
        }
      ]
    },
    // Categoría de Interactivos
    {
      name: "Interactivos",
      color: "#7986cb", // Indigo claro (Mejor visibilidad en modo oscuro)
      icon: <TbDeviceMobile size={24} />,
      nodes: [
        {
          icon: <TbDeviceMobile size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.buttonInteractive.name") || "Botones Interactivos",
          type: "buttonInteractive",
          description: i18n.t("flowBuilder.editor.nodes.buttonInteractive.description") || "Envía hasta 3 botones de respuesta rápida y/o botones CTA."
        },
        {
          icon: <TbDeviceMobile size={24} />,
          name: "Carrusel",
          type: "carouselInteractive",
          description: "Envía un carrusel de hasta 10 tarjetas con imágenes y botones."
        },
        {
          icon: <TbListDetails size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.listInteractive.name") || "Lista Interactiva",
          type: "listInteractive",
          description: i18n.t("flowBuilder.editor.nodes.listInteractive.description") || "Envía una lista con hasta 10 opciones seleccionables."
        },
        {
          icon: <TbForms size={24} />,
          name: i18n.t("flowBuilder.editor.nodes.poll.name") || "Encuesta",
          type: "poll",
          description: i18n.t("flowBuilder.editor.nodes.poll.description") || "Enviar una encuesta nativa"
        }
      ]
    }
  ], [i18n.language]);

  // Estados existentes (mantidos)
  // const { user } = useContext(AuthContext); // Removido duplicado
  const [loading, setLoading] = useState(false);
  const [dataNode, setDataNode] = useState(null);

  // Estados dos modais (mantidos)
  const [modalAddText, setModalAddText] = useState(null);
  const [modalAddInterval, setModalAddInterval] = useState(false);
  const [modalAddTicketStatus, setModalAddTicketStatus] = useState(false);
  //const [modalAddCondition, setModalAddCondition] = useState(null);
  const [modalAddMenu, setModalAddMenu] = useState(null);
  const [modalAddImg, setModalAddImg] = useState(null);
  const [modalAddDoc, setModalAddDoc] = useState(null);
  const [modalAddAudio, setModalAddAudio] = useState(null);
  const [modalAddRandomizer, setModalAddRandomizer] = useState(null);
  const [modalAddVideo, setModalAddVideo] = useState(null);
  const [modalAddSingleBlock, setModalAddSingleBlock] = useState(null);
  const [modalAddTicket, setModalAddTicket] = useState(null);
  const [modalAddTag, setModalAddTag] = useState(null);
  const [modalAddSwitchFlow, setModalAddSwitchFlow] = useState(null);
  const [modalAddAttendant, setModalAddAttendant] = useState(null);
  const [modalAddOpenAI, setModalAddOpenAI] = useState(null);
  const [modalAddGemini, setModalAddGemini] = useState(null);
  const [modalAddInput, setModalAddInput] = useState(null);
  const [modalAddPoll, setModalAddPoll] = useState(null);
  const [modalAddConditionCompare, setModalAddConditionCompare] = useState(null);
  const [modalAddRemoveTag, setModalAddRemoveTag] = useState(null);
  const [modalAddJump, setModalAddJump] = useState(null);
  const [modalAddRetargeting, setModalAddRetargeting] = useState(null); // ESTADO DO MODAL JUMP
  const [modalAddRemarketing, setModalAddRemarketing] = useState(null); // [ANTIGRAVITY] ESTADO DEL MODAL REMARKETING
  const [modalAddPaymentValidation, setModalAddPaymentValidation] = useState(null);
  const [modalKnowledgeOpen, setModalKnowledgeOpen] = useState(false);
  const [whatsappIds, setWhatsappIds] = useState([]);
  const [flowKanbanId, setFlowKanbanId] = useState(null);
  const [flowBrandId, setFlowBrandId] = useState(null);
  const [modalAddScheduling, setModalAddScheduling] = useState(null);
  // [Plan 904] Estados modales META API
  const [modalAddButtonInteractive, setModalAddButtonInteractive] = useState(null);
  const [modalAddCarouselInteractive, setModalAddCarouselInteractive] = useState(null);
  const [modalAddListInteractive, setModalAddListInteractive] = useState(null);
  // [Plan 928] Estados modales Form / Notifier
  const [modalAddForm, setModalAddForm] = useState(null);
  const [modalAddNotifier, setModalAddNotifier] = useState(null);
  const [modalAddSaveContact, setModalAddSaveContact] = useState(null);

  // [ANTIGRAVITY] Plan 899 — AI Simulator Open State
  const [simulatorOpen, setSimulatorOpen] = useState(false);
  // simulatorAiNodeData is declared AFTER useNodesState below to avoid TDZ

  // Estados ReactFlow (mantidos)
  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);

  // [ANTIGRAVITY] Plan 899 — Auto-detect first AI node for simulator (AFTER nodes declaration)
  const simulatorAiNodeData = React.useMemo(() => {
    const aiNode = nodes.find(n => n.type === "openai" || n.type === "gemini");
    return aiNode ? aiNode.data : null;
  }, [nodes]);
  const [hasChanges, setHasChanges] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [openAiModalOpen, setOpenAiModalOpen] = useState(false);
  const [pendingLocation, setPendingLocation] = useState(null);
  const history = useHistory();
  const storageItems = useNodeStorage();
  const unblockRef = useRef(null); // [ANTIGRAVITY] FIX: Store unblock function to prevent double confirmation loop

  // Guard de fechamento do navegador
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasChanges) {
        e.preventDefault();
        e.returnValue = i18n.t("flowBuilder.editor.messages.unsavedChanges") || "Você tem alterações não salvas. Tem certeza de que deseja sair?";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [hasChanges]);

  // Interceptar navegação interna do React Router
  useEffect(() => {
    if (!hasChanges) return;

    const unblock = history.block((location) => {
      setPendingLocation(location);
      setShowConfirmModal(true);
      return false; // Bloqueia a navegação inicial
    });

    unblockRef.current = unblock; // [ANTIGRAVITY] Save unblocker

    return () => {
      unblock();
      unblockRef.current = null;
    };
  }, [hasChanges, history]);
  const handleConfirmExit = () => {
    setHasChanges(false); // Permite a navegação
    setShowConfirmModal(false);

    // [ANTIGRAVITY] FIX: Unblock explicitly before pushing
    if (unblockRef.current) {
      unblockRef.current();
      unblockRef.current = null;
    }

    if (pendingLocation) {
      history.push(pendingLocation.pathname);
    }
  };

  // Monitorar mudanças nos nós e conexões


  const onEdgeUpdate = (oldEdge, newConnection) => {
    setEdges((els) => updateEdge(oldEdge, newConnection, els));
    setHasChanges(true);
  };

  const connectionLineStyle = {
    stroke: "#FF9800",
    strokeWidth: 2
  };

  // Inicializar sistema de variáveis globais
  useEffect(() => {
    if (!window.flowVariables) {
      window.flowVariables = {};
    }
    window.getFlowVariable = getFlowVariable;
    window.setFlowVariable = setFlowVariable;
  }, []);

  // React Flow Hooks (Restored)
  const reactFlowWrapper = useRef(null);
  const reactFlowInstance = useReactFlow();

  const addNode = useCallback((type, data) => {
    let posX, posY;

    if (data && data.position) {
      posX = data.position.x;
      posY = data.position.y;
    } else {
      posY = nodes.length > 0 ? nodes[nodes.length - 1].position.y : 100;
      posX = nodes.length > 0 ? nodes[nodes.length - 1].position.x + (nodes[nodes.length - 1].width || 200) + 40 : 250;
    }

    if (type === "start") {
      return setNodes(old => {
        return [
          ...old.filter(item => item.id !== "1"),
          {
            id: "1",
            position: { x: posX, y: posY },
            data: { label: "Inicio do fluxo" },
            type: "start"
          }
        ];
      });
    }

    if (type === "message") {
      return setNodes(old => {
        const autoName = generateNodeName("message", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { label: data.text || "Texto", name: autoName, ...data },
            type: "message"
          }
        ];
      });
    }

    if (type === "interval") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { label: `Intervalo ${data.sec} seg.`, sec: data.sec },
            type: "interval"
          }
        ];
      });
    }

    if (type === "menu") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              message: data.message,
              arrayOption: data.arrayOption || [],
              typeMenu: data.typeMenu || "number",
              listTitle: data.listTitle || "",
              listButtonText: data.listButtonText || "Opciones",
              listFooter: data.listFooter || ""
            },
            type: "menu"
          }
        ];
      });
    }


    // [ANTIGRAVITY] Removed duplicate legacy jump block



    if (type === "img") {
      return setNodes(old => {
        const autoName = generateNodeName("img", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { url: data.url, name: autoName, ...data }, // Auto-name
            type: "img"
          }
        ];
      });
    }

    if (type === "doc") {
      return setNodes(old => {
        const autoName = generateNodeName("doc", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { url: data.url, name: autoName, ...data }, // Auto-name
            type: "doc"
          }
        ];
      });
    }

    if (type === "audio") {
      return setNodes(old => {
        const autoName = generateNodeName("audio", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { url: data.url, record: data.record, name: autoName, ...data }, // Auto-name
            type: "audio"
          }
        ];
      });
    }

    if (type === "randomizer") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              percent: data.percent || 50,
              percents: data.percents || [data.percent || 50, 100 - (data.percent || 50)]
            },
            type: "randomizer"
          }
        ];
      });
    }

    if (type === "video") {
      return setNodes(old => {
        const autoName = generateNodeName("video", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { url: data.url, name: autoName, ...data }, // Auto-name
            type: "video"
          }
        ];
      });
    }

    if (type === "singleBlock") {
      return setNodes(old => {
        const autoName = generateNodeName("singleBlock", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              seq: [],
              elements: [],
              name: autoName,
              ...data
            },
            type: "singleBlock"
          }
        ];
      });
    }

    if (type === "ticket") {
      return setNodes(old => {
        const autoName = generateNodeName("ticket", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { name: autoName, ...data }, // Auto-name
            type: "ticket"
          }
        ];
      });
    }

    if (type === "regex") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              sourceVariable: (data && data.sourceVariable) || "triggerMessage",
              regexPattern: (data && data.regexPattern) || "",
              outputVariable: (data && data.outputVariable) || "extracted_text",
              ...data,
            },
            type: "regex",
          },
        ];
      });
    }

    if (type === "openai") {
      return setNodes(old => {
        const autoName = generateNodeName("openai", old);
        // [ANTIGRAVITY] Auto-Increment Variable
        const match = autoName.match(/(\d+)$/);
        const number = match ? match[1] : (old.filter(n => n.type === "openai").length + 1);
        const autoVar = `ai_action${number}`;

        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              ...data,
              name: autoName,
              outputVariableName: autoVar,
              typebotIntegration: {
                handles: [
                  {
                    name: "TRANSFER_SUPPORT",
                    label: "Transferir a Soporte",
                    cancelRemarketing: true,
                    immediateMessage: "",
                    autoCloseEnabled: true,
                    autoCloseDelay: 20,
                    autoCloseMessage: "Cierre del Ticket Obligatorio por falta de Conectividad."
                  }
                ],
                model: "gpt-4o",
                flowMode: "permanent",
                continueKeywords: ["continuar", "próximo", "avançar"],
                maxInteractions: 5,
                completionTimeout: 10,
                objective: "",
                autoCompleteOnObjective: false,
                debounceTime: 0,
                ragEnabled: true,
                ragThreshold: 0.7,
                remarketingEnabled: true, // [ANTIGRAVITY] Mandatory Remarketing
                remarketingTasks: [
                  {
                    id: Date.now() + 999123,
                    isFinalTask: true,
                    isLastTask: true,
                    waitTime: 20,
                    waitUnit: 'minutes',
                    variable: `final_closure_${Date.now()}`,
                    content: [
                      { type: 'text', value: "Estuve atento a tu respuesta. Tal vez en estos momentos estés ocupad@, pero, descuida, puedes volver a escribirnos cuando te encuentres disponible para continuar con tu atención. ¡Te esperamos!" }
                    ],
                    order: 1,
                    closeTicket: true
                  }
                ]
              },
            },
            type: "openai",
          },
        ];
      });
    }

    if (type === "gemini") {
      return setNodes(old => {
        const autoName = generateNodeName("gemini", old);
        // [ANTIGRAVITY] Auto-Increment Variable
        const match = autoName.match(/(\d+)$/);
        const number = match ? match[1] : (old.filter(n => n.type === "gemini").length + 1);
        const autoVar = `gemini_action${number}`;

        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              ...data,
              name: autoName,
              outputVariableName: autoVar
            },
            type: "gemini",
          },
        ];
      });
    }

    if (type === "tag") {
      return setNodes(old => {
        const autoName = generateNodeName("tag", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { name: autoName, ...data },
            type: "tag"
          }
        ];
      });
    }

    if (type === "kanban") {
      return setNodes(old => {
        const autoName = generateNodeName("kanban", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { name: autoName, ...data }, // Auto-name
            type: "kanban"
          }
        ];
      });
    }

    if (type === "removeTag") {
      return setNodes((old) => {
        const autoName = generateNodeName("removeTag", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              name: autoName,
              tag: (data && data.tag) || "",
              ...data,
            },
            type: "removeTag",
          },
        ];
      });
    }

    if (type === "switchFlow") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { ...data },
            type: "switchFlow"
          }
        ];
      });
    }

    if (type === "attendant") {
      return setNodes(old => {
        const autoName = generateNodeName("attendant", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { name: autoName, ...data }, // Auto-name
            type: "attendant"
          }
        ]
      })
    }

    if (type === "ticketStatus") {
      return setNodes(old => {
        const autoName = generateNodeName("ticketStatus", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { name: autoName, status: "closed", ...data },
            type: "ticketStatus"
          }
        ]
      })
    }

    // [ANTIGRAVITY] Cleaned up duplicate jump block


    if (type === "httpRequest") {
      return setNodes((old) => {
        const autoName = generateNodeName("httpRequest", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              url: "",
              method: (data && data.method) || "POST",
              requestBody: (data && data.requestBody) || "{ }",
              headersString: (data && data.headersString) || "",
              queryParams: (data && data.queryParams) || [],
              saveVariables: (data && data.saveVariables) || [],
              name: autoName, // Auto-name
              ...data,
            },
            type: "httpRequest",
          },
        ]
      });
    }

    if (type === "variable") {
      return setNodes((old) => {
        const autoName = generateNodeName("variable", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              variableName: (data && data.variableName) || "",
              variableValue: (data && data.variableValue) || "",
              variableType: (data && data.variableType) || "text",
              variableExpression: (data && data.variableExpression) || "",
              isExpression: (data && data.isExpression) || false,
              name: autoName,
              ...data,
            },
            type: "variable",
          },
        ];
      });
    }

    if (type === "input") {
      return setNodes((old) => {
        const autoName = generateNodeName("input", old);
        const timestamp = Date.now();
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              question: (data && data.question) || "",
              variableName: (data && data.variableName) || "",
              name: autoName, // Auto-name
              // [ANTIGRAVITY] Default Remarketing Configuration for NEW nodes
              remarketingEnabled: true,
              remarketingTasks: [
                {
                  id: timestamp + 999123,
                  isFinalTask: true,
                  isLastTask: true,
                  waitTime: 20,
                  waitUnit: 'minutes',
                  variable: `final_closure_${timestamp}`,
                  content: [
                    { type: 'text', value: "Estuve atento a tu respuesta. Tal vez en estos momentos estés ocupad@, pero, descuida, puedes volver a escribirnos cuando te encuentres disponible para continuar con tu atención. ¡Te esperamos!" }
                  ],
                  order: 1,
                  closeTicket: true
                }
              ],
              ...data,
            },
            type: "input",
          },
        ];
      });
    }

    if (type === "poll") {
      return setNodes((old) => {
        const autoName = generateNodeName("poll", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              name: autoName, // Auto-name
              question: "",
              options: ["", ""],
              multipleSelection: false,
              variableName: "",
              ...data,
            },
            type: "poll",
          },
        ];
      });
    }

    if (type === "conditionCompare") {
      return setNodes((old) => {
        const autoName = generateNodeName("conditionCompare", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              name: autoName, // Auto-name
              leftValue: (data && data.leftValue) || "",
              operator: (data && data.operator) || "equals",
              rightValue: (data && data.rightValue) || "",
              ...data,
            },
            type: "conditionCompare",
          },
        ];
      });
    }
    if (type === "jump") {
      // Standard Behavior: If dropping, create immediately.
      if (data && data.position) {
        setHasChanges(true);
        return setNodes(old => {
          const autoName = generateNodeName("jump", old);
          return [
            ...old,
            {
              id: geraStringAleatoria(30),
              position: { x: posX, y: posY },
              type: "jump",
              data: { name: autoName, destinationNodeId: "" }
            }
          ];
        });
      }
      setModalAddJump("create");
      return;
    }

    if (type === "paymentValidation") {
      return setNodes((old) => {
        const autoName = generateNodeName("paymentValidation", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              name: autoName,
              ...data,
            },
            type: "paymentValidation",
          },
        ];
      });
    }

    if (type === "scheduling") {
      return setNodes((old) => {
        const autoName = generateNodeName("scheduling", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              name: autoName,
              ...data,
            },
            type: "scheduling",
          },
        ];
      });
    }

    // [Plan 904] — Botones Interactivos META API
    if (type === "buttonInteractive") {
      return setNodes((old) => {
        const autoName = generateNodeName("buttonInteractive", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              name: autoName,
              body: "",
              buttons: [
                { id: "btn_1", text: "" },
                { id: "btn_2", text: "" }
              ],
              ctaUrl: { label: "", url: "" },
              ctaPhone: { label: "", phone: "" },
              ...data,
            },
            type: "buttonInteractive",
          },
        ];
      });
    }

    if (type === "carouselInteractive") {
      return setNodes((old) => {
        const autoName = generateNodeName("carouselInteractive", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              name: autoName,
              body: "",
              cards: [
                { id: "card_1", imageURL: "", headerText: "", bodyText: "", buttons: [{ id: "btn_1", text: "", type: "reply", payload: "" }] }
              ],
              ...data,
            },
            type: "carouselInteractive",
          },
        ];
      });
    }



    // [Plan 904] — Lista Interactiva META API
    if (type === "listInteractive") {
      return setNodes((old) => {
        const autoName = generateNodeName("listInteractive", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              name: autoName,
              header: "",
              body: "",
              buttonText: "Ver opciones",
              rows: [
                { id: "row_1", title: "", description: "" },
                { id: "row_2", title: "", description: "" }
              ],
              ...data,
            },
            type: "listInteractive",
          },
        ];
      });
    }
    // Formulario Web (Plan 928)
    if (type === "form") {
      return setNodes((old) => {
        const autoName = generateNodeName("form", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              name: autoName,
              formId: "",
              formSlug: "",
              formName: "",
              message: "Por favor, completa el siguiente formulario: {link}",
              ...data,
            },
            type: "form",
          },
        ];
      });
    }

    // Notificador WhatsApp (Plan 928)
    if (type === "notifier") {
      return setNodes((old) => {
        const autoName = generateNodeName("notifier", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              name: autoName,
              destinationNumber: "",
              message: "Nuevo pedido recibido. Nombre: {{nombre}}",
              ...data,
            },
            type: "notifier",
          },
        ];
      });
    }
    
    // Retargeting
    if (type === "retargeting") {
      return setNodes((old) => {
        const autoName = generateNodeName("retargeting", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              name: autoName,
              tasks: [],
              cancelOnReply: false,
              ...data,
            },
            type: "retargeting",
          },
        ];
      });
    }

    if (type === "remarketing") {
      return setNodes((old) => {
        const autoName = generateNodeName("remarketing", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              name: autoName,
              tasks: [],
              cancelOnReply: false,
              ...data,
            },
            type: "remarketing",
          },
        ];
      });
    }
    
    // Guardar Contacto (Plan 928)
    if (type === "saveContact") {
      return setNodes((old) => {
        const autoName = generateNodeName("saveContact", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              name: autoName,
              field: "",
              variable: "",
              ...data,
            },
            type: "saveContact",
          },
        ];
      });
    }

    if (type === "listMatch") {
      return setNodes((old) => {
        const autoName = generateNodeName("listMatch", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              name: autoName,
              inputVariable: "",
              outputVariable: "",
              optionsList: "",
              ...data,
            },
            type: "listMatch",
          },
        ];
      });
    }
  }, [nodes, setNodes]);

  // Funções de adição (mantidas)
  const textAdd = data => addNode("text", data);
  const intervalAdd = data => addNode("interval", data);
  const ticketStatusAdd = data => addNode("ticketStatus", data);
  //const conditionAdd = data => addNode("condition", data);
  const menuAdd = data => addNode("menu", data);
  const imgAdd = data => addNode("img", data);
  const docAdd = data => addNode("doc", data);
  const audioAdd = data => addNode("audio", data);
  const randomizerAdd = data => addNode("randomizer", data);
  const videoAdd = data => addNode("video", data);

  const ticketAdd = data => addNode("ticket", data);
  const tagAdd = data => addNode("tag", data);
  const openaiAdd = data => addNode("openai", data);
  const remarketingAdd = data => addNode("remarketing", data);
  const geminiAdd = data => addNode("gemini", data);
  const removeTagAdd = data => addNode("removeTag", data);
  const switchFlowAdd = data => addNode("switchFlow", data);
  const attendantAdd = data => addNode("attendant", data);
  const variableAdd = data => addNode("variable", data);
  const regexAdd = data => addNode("regex", data);
  const inputAdd = data => addNode("input", data);
  const pollAdd = data => addNode("poll", data);
  const conditionCompareAdd = data => addNode("conditionCompare", data);
  const paymentValidationAdd = data => addNode("paymentValidation", data);
  const schedulingAdd = data => addNode("scheduling", data);
  const formAdd = data => addNode("form", data);
  const notifierAdd = data => addNode("notifier", data);
  const saveContactAdd = data => addNode("saveContact", data);

  // useEffect para carregar fluxo COMPLETO (mantido)
  useEffect(() => {
    setLoading(true);
    const fetchContacts = async () => {
      try {
        const { data } = await api.get(`/flowbuilder/flow/${id}`);

        try {
          const flowCampaigns = data.flow.campaigns || [];

          const ids = new Set();
          flowCampaigns.forEach(c => {
            if (c.whatsappIds && Array.isArray(c.whatsappIds)) {
              c.whatsappIds.forEach(wid => ids.add(Number(wid)));
            }
            if (c.whatsappId) {
              ids.add(Number(c.whatsappId));
            }
          });

          const finalIds = [...ids];
          setWhatsappIds(finalIds);
        } catch (err) {
          console.error("Error processing linked campaigns:", err);
        }

        if (data.flow) {
          setFlowName(data.flow.name || "");
          setFlowKanbanId(data.flow.kanbanId || null);
          setFlowBrandId(data.flow.brandId || null);
        }

        if (data.flow.flow !== null) {
          const preparedNodes = data.flow.flow.nodes.map((node) => {
            if (node.type === "httpRequest") {
              if (node.data.saveVariables && node.data.saveVariables.length > 0) {
                if (
                  !node.data.responseVariables ||
                  !Array.isArray(node.data.responseVariables)
                ) {
                  node.data.responseVariables = node.data.saveVariables.map(
                    (item) => ({
                      path: item.path,
                      variableName: item.variable,
                    })
                  );
                }
              } else {
                node.data.saveVariables = node.data.saveVariables || [];
                node.data.responseVariables = node.data.responseVariables || [];
              }
            }
            return node;
          });

          setNodes(preparedNodes);
          setEdges(data.flow.flow.connections.map(edge => ({ ...edge, type: 'buttonedge' })));
        }
        setLoading(false);
      } catch (err) {
        toastError(err);
      }
    };
    fetchContacts();
  }, [id]);

  // useEffect para storage COMPLETO (mantido)
  useEffect(() => {
    if (storageItems.action === "delete") {
      setNodes(old => old.filter(item => item.id !== storageItems.node));
      setEdges(old => {
        const newData = old.filter(item => item.source !== storageItems.node);
        const newClearTarget = newData.filter(
          item => item.target !== storageItems.node
        );
        return newClearTarget;
      });
      storageItems.setNodesStorage("");
      storageItems.setAct("idle");
    }
    if (storageItems.action === "duplicate") {
      const nodeDuplicate = nodes.filter(
        item => item.id === storageItems.node
      )[0];

      if (nodeDuplicate) {
        const nodeNew = {
          ...nodeDuplicate,
          id: geraStringAleatoria(30),
          position: {
            x: nodeDuplicate.position.x + 50,
            y: nodeDuplicate.position.y + 50
          },
          selected: false,
          style: {
            backgroundColor: theme.palette.grey[800],
            padding: 0,
            borderRadius: 8,
            border: `1px solid ${theme.palette.divider} `
          }
        };
        setNodes(old => [...old, nodeNew]);
      } else {
        console.warn("[FlowBuilder] Erro ao duplicar: Nó não encontrado:", storageItems.node);
      }

      storageItems.setNodesStorage("");
      storageItems.setAct("idle");
    }
  }, [storageItems.action, nodes, theme]);

  const { undo, redo, takeSnapshot, canUndo, canRedo } = useUndoRedo({
    nodes,
    setNodes,
    edges,
    setEdges
  });

  // Atalhos de teclado para Undo/Redo
  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key === 'z') {
        if (event.shiftKey) {
          event.preventDefault();
          redo();
        } else {
          event.preventDefault();
          undo();
        }
      } else if ((event.ctrlKey || event.metaKey) && event.key === 'y') {
        event.preventDefault();
        redo();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [undo, redo]);

  // Handler for Kanban
  const kanbanAdd = (data) => {
    const isNew = modalAddKanban === "create";
    if (isNew) {
      setNodes((old) => {
        const autoName = generateNodeName("kanban", old);
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: 250, y: 100 },
            data: { name: autoName, ...data }, // Auto-name
            type: "kanban",
          },
        ];
      });
    } else {
      setNodes((old) =>
        old.map((node) => {
          if (node.id === dataNode.id) {
            return {
              ...node,
              data: { ...data },
            };
          }
          return node;
        })
      );
    }
    setModalAddKanban(null);
    setHasChanges(true);
  };

  // Handler para SingleBlock (Conteúdo Unificado)
  const singleBlockAdd = (data) => {
    const isNew = modalAddSingleBlock === "create";

    if (isNew) {
      setNodes((old) => [
        ...old,
        {
          id: geraStringAleatoria(30),
          position: { x: 250, y: 100 },
          data: { ...data },
          type: "singleBlock",
        },
      ]);
    } else {
      setNodes((old) =>
        old.map((node) => {
          if (node.id === dataNode.id) {
            return {
              ...node,
              data: { ...data },
            };
          }
          return node;
        })
      );
    }
    setModalAddSingleBlock(null);
    setHasChanges(true); // Marcar que hubo cambios
  };

  const onConnect = useCallback(
    params => {

      takeSnapshot(); // Salvar estado antes de conectar
      setEdges((eds) => {
        // Enforce single connection per source handle
        const filtered = eds.filter(e => !(e.source === params.source && e.sourceHandle === params.sourceHandle));
        return addEdge({ ...params, type: 'buttonedge' }, filtered);
      });
      setHasChanges(true);
    },
    [setEdges, takeSnapshot]
  );

  const onNodeDragStart = (event, node) => {
    takeSnapshot();
  };

  const onNodesDelete = (nodesToDelete) => {
    takeSnapshot();
  };

  const onEdgesDelete = (edgesToDelete) => {
    takeSnapshot();
  };

  // Função de salvar COMPLETA (mantida)
  // Função de salvar COMPLETA (mantida)
  const saveFlow = async () => {
    try {
      // [ANTIGRAVITY] Auto-Repair: Remove duplicate 'start' nodes
      let startNodesCount = 0;
      let firstStartNodeId = null;
      let deduplicatedNodes = [];
      let nodesRemoved = 0;
      
      for (let i = 0; i < nodes.length; i++) {
        const n = nodes[i];
        if (n.type === 'start') {
          if (startNodesCount === 0) {
            firstStartNodeId = n.id;
            deduplicatedNodes.push(n);
            startNodesCount++;
          } else {
            nodesRemoved++;
          }
        } else {
          deduplicatedNodes.push(n);
        }
      }
      
      if (nodesRemoved > 0) {
        
        // Remove edges associated with removed start nodes
        setEdges((eds) => eds.filter(e => {
            const sourceNode = nodes.find(n => n.id === e.source);
            if (sourceNode && sourceNode.type === 'start' && e.source !== firstStartNodeId) {
                return false;
            }
            return true;
        }));
      }

      // [ANTIGRAVITY] Auto-Repair: Fix missing names before validation
      let updatedNodes = deduplicatedNodes;
      let repairedCount = 0;

      for (let i = 0; i < updatedNodes.length; i++) {
        const node = updatedNodes[i];
        let nodeModified = false;
        let newData = { ...node.data };

        // 1. Auto-Repair: Missing Names OR Legacy/Default Names (Fix per User Request)
        const currentName = (node.data && node.data.name) || "";
        const trimmedName = currentName.trim();

        // Define default names based on current language
        const defaultOpenAI = i18n.t("flowBuilder.editor.nodes.openai.name");
        const defaultKanban = i18n.t("flowBuilder.kanban.name");
        const defaultCondition = i18n.t("flowBuilder.editor.nodes.condition.name");
        const defaultConditionCompare = i18n.t("flowBuilder.conditionCompare.title");

        const needsRepair = !currentName ||
          trimmedName === '' ||
          trimmedName === "Asistente IA" || trimmedName === defaultOpenAI ||
          trimmedName === "Kanban" || trimmedName === defaultKanban ||
          trimmedName === "Condiciones" || trimmedName === defaultCondition || trimmedName === defaultConditionCompare ||
          trimmedName === "Nodo";

        if (needsRepair && node.type !== 'start' && node.type !== 'interval') {
          const newName = generateNodeName(node.type, updatedNodes);
          newData.name = newName;

          // [ANTIGRAVITY] Auto-Increment Variable Logic
          if (node.type === "openai") {
            const match = newName.match(/(\d+)$/);
            const number = match ? match[1] : "1";
            newData.outputVariableName = `ai_action${number}`;
            newData.outputVariableName = `ai_action${number}`;
          }
          if (node.type === "gemini") {
            const match = newName.match(/(\d+)$/);
            const number = match ? match[1] : "1";
            newData.outputVariableName = `gemini_action${number}`;
          }

          nodeModified = true;
          nodeModified = true;
        }

        // [ANTIGRAVITY] Auto-repair for Input nodes removed to respect user settings.

        if (nodeModified) {
          updatedNodes[i] = {
            ...node,
            data: newData
          };
          repairedCount++;
        }
      }

      if (repairedCount > 0) {
        setNodes(updatedNodes);
        toast.success(`Se repararon ${repairedCount} nodos sem nome automaticamente.`);
      }

      // [ANTIGRAVITY] Auto-Repair Duplicates: Ensure uniqueness
      const usedNames = new Set();
      let duplicatesRepaired = 0;

      for (let i = 0; i < updatedNodes.length; i++) {
        const node = updatedNodes[i];
        // Skip check for ignored types
        if (node.type === 'start' || node.type === 'interval') continue;

        let name = node.data.name;
        // If empty, it's skipped here (should have been fixed above, or is irrelevant type)
        if (!name || name.trim() === '') continue;

        if (usedNames.has(name.trim())) {
          // Collision detected
          let safeName = name;
          let counter = 1;
          while (usedNames.has(safeName.trim())) {
            safeName = `${name} ${counter}`;
            counter++;
          }

          updatedNodes[i] = {
            ...node,
            data: { ...node.data, name: safeName }
          };
          duplicatesRepaired++;
          name = safeName;
        }
        usedNames.add(name.trim());
      }

      if (duplicatesRepaired > 0) {
        setNodes(updatedNodes);
        toast.success(`Se renomearam ${duplicatesRepaired} nós duplicados automaticamente.`);
      }

      // [ANTIGRAVITY] Validation: Check for unique names and empty names using UPDATED nodes
      const nameSet = new Set();
      const duplicateNames = [];
      const missingNameNodes = [];

      for (const node of updatedNodes) {
        // Skip Start and Interval node validation
        if (node.type === 'start' || node.type === 'interval') continue;

        const nodeName = node.data.name;

        if (!nodeName || nodeName.trim() === '') {
          missingNameNodes.push(node.type);
          continue;
        }

        if (nameSet.has(nodeName.trim())) {
          duplicateNames.push(nodeName);
        }
        nameSet.add(nodeName.trim());
      }

      if (missingNameNodes.length > 0) {
        toast.error(`Error: Existem ${missingNameNodes.length} nós sem nome. Por favor, atribua-lhes um nome.`);
        return;
      }

      if (duplicateNames.length > 0) {
        toast.error(`Error: Nomes duplicados detectados: ${duplicateNames.join(', ')}. Os nomes devem ser únicos.`);
        return;
      }

      // [ANTIGRAVITY] Infinite Loop Validation
      const loopCheck = validateInfiniteLoops(updatedNodes, edges);
      if (loopCheck.error) {
        // Show specific error about the loop
        toast.error(loopCheck.message, { autoClose: 10000 });
        // Highlight the bad node if possible (optional: select it)
        if (loopCheck.node) {
          setNodes((nds) => nds.map(n => ({
            ...n,
            selected: n.id === loopCheck.node.id, // Select the culprit
            style: { ...n.style, border: n.id === loopCheck.node.id ? '3px solid red' : n.style.border }
          })));
        }
        return;
      }

      // [ANTIGRAVITY] Preparing to save flow
      const processedNodes = updatedNodes.map((node) => {
        if (node.type === "httpRequest") {
          // [ANTIGRAVITY] Processing HTTP Request node
          if (node.data.saveVariables && node.data.saveVariables.length > 0) {
            if (
              !node.data.responseVariables ||
              !Array.isArray(node.data.responseVariables)
            ) {
              node.data.responseVariables = node.data.saveVariables.map(
                (item) => ({
                  path: item.path,
                  variableName: item.variable,
                })
              );
            }
          } else {
            node.data.saveVariables = node.data.saveVariables || [];
            node.data.responseVariables = node.data.responseVariables || [];
          }
        }
        return node;
      });

      // [ANTIGRAVITY] Sending flow to server

      await api
        .post("/flowbuilder/flow", {
          idFlow: id,
          nodes: processedNodes,
          connections: edges,
        })
        .then((res) => {
          toast.success(i18n.t("flowBuilder.editor.toasts.saveSuccess"));
          setNodes(processedNodes);
          setHasChanges(false);
        });
    } catch (error) {
      toast.error(i18n.t("flowBuilder.editor.toasts.saveError"));
      console.error("Erro ao salvar o fluxo:", error);
    }
  };

  // Event handlers COMPLETOS (mantidos mas adaptados para tema)
  const doubleClick = (event, node) => {
    setDataNode(node);
    if (node.type === "message") setModalAddText("edit");
    if (node.type === "interval") setModalAddInterval("edit");
    if (node.type === "ticketStatus") setModalAddTicketStatus("edit");
    if (node.type === "menu") setModalAddMenu("edit");
    if (node.type === "img") setModalAddImg("edit");
    if (node.type === "doc") setModalAddDoc("edit");
    if (node.type === "audio") setModalAddAudio("edit");
    if (node.type === "randomizer") setModalAddRandomizer("edit");
    if (node.type === "video") setModalAddVideo("edit");
    if (node.type === "singleBlock") {
      setModalAddSingleBlock("edit");
    }
    if (node.type === "ticket") setModalAddTicket("edit");
    if (node.type === "kanban") setModalAddKanban("edit");
    if (node.type === "tag") setModalAddTag("edit");
    if (node.type === "removeTag") setModalAddRemoveTag("edit");
    if (node.type === "switchFlow") setModalAddSwitchFlow("edit");
    if (node.type === "openai") setModalAddOpenAI("edit");
    if (node.type === "remarketing") setModalAddRemarketing("edit");
    if (node.type === "gemini") setModalAddGemini("edit");
    if (node.type === "attendant") setModalAddAttendant("edit");
    if (node.type === "jump") setModalAddJump("edit");
    if (node.type === "paymentValidation") setModalAddPaymentValidation("edit");
    if (node.type === "retargeting") setModalAddRetargeting("edit");
    if (node.type === "httpRequest") {
      if (node.data.saveVariables && node.data.saveVariables.length > 0) {
        if (
          !node.data.responseVariables ||
          !Array.isArray(node.data.responseVariables)
        ) {
          node.data.responseVariables = node.data.saveVariables.map((item) => ({
            path: item.path,
            variableName: item.variable,
          }));

          setNodes((old) =>
            old.map((itemNode) => {
              if (itemNode.id === node.id) {
                return node;
              }
              return itemNode;
            })
          );
          // [ANTIGRAVITY] HTTP Request node updated
        }
      }
    }
    if (node.type === "input") {
      setDataNode(node);
      setModalAddInput("edit");
    }

    if (node.type === "poll") {
      setDataNode(node);
      setModalAddPoll("edit");
    }

    if (node.type === "conditionCompare") {
      setDataNode(node);
      setModalAddConditionCompare("edit");
    }

    if (node.type === "scheduling") {
      setDataNode(node);
      setModalAddScheduling("edit");
    }
    // [Plan 904] — Doble clic en nodos META API
    if (node.type === "buttonInteractive") {
      setDataNode(node);
      setModalAddButtonInteractive("edit");
    }
    if (node.type === "carouselInteractive") {
      setDataNode(node);
      setModalAddCarouselInteractive("edit");
    }
    if (node.type === "listInteractive") {
      setDataNode(node);
      setModalAddListInteractive("edit");
    }
    // Form and Notifier (Plan 928)
    if (node.type === "form") {
      setDataNode(node);
      setModalAddForm("edit");
    }
    if (node.type === "notifier") {
      setDataNode(node);
      setModalAddNotifier("edit");
    }
    if (node.type === "saveContact") {
      setDataNode(node);
      setModalAddSaveContact("edit");
    }
  };

  const clickNode = (event, node) => {
    // Helper to determine border radius based on node type
    const getBorderRadius = (type) => {
      switch (type) {
        case "start":
          return "8px";
        case "conditionCompare":
        case "condition":
          return "12px"; // Updated to match Message Node style
        case "ticket":
        case "randomizer":
        case "switchFlow":
        case "tag":
        case "removeTag":
        case "singleBlock":
          return "8px"; // Most square-ish nodes
        default:
          return "12px"; // Default for Message, Audio, Video, etc.
      }
    };

    setNodes(old =>
      old.map(item => {

        const radius = getBorderRadius(item.type);
        if (item.id === node.id) {
          return {
            ...item,
            style: {
              ...item.style,
              // Make wrapper transparent for input nodes so internal styling takes over completely
              backgroundColor: ['input', 'inputNode', 'question'].includes(item.type) ? 'transparent' : theme.palette.background.paper,
              borderRadius: radius,
              // Use transparent border to maintain layout mapping but hide visual
              border: ['input', 'inputNode', 'question'].includes(item.type) ? '2px solid transparent' : `2px solid ${theme.palette.primary.main} `, // Purple Selected
              padding: 0,
              boxShadow: ['input', 'inputNode', 'question'].includes(item.type) ? 'none' : '0 3px 5px rgba(0,0,0,0.1)'
            },
            selected: true,
            data: { ...item.data, selected: true }
          };
        }
        return {
          ...item,
          style: {
            ...item.style,
            // Make wrapper transparent for input nodes
            backgroundColor: ['input', 'inputNode', 'question'].includes(item.type) ? 'transparent' : theme.palette.background.paper,
            borderRadius: radius,
            border: ['input', 'inputNode', 'question'].includes(item.type) ? '2px solid transparent' : `2px solid #FF9800`, // Orange Unselected
            padding: 0,
            boxShadow: ['input', 'inputNode', 'question'].includes(item.type) ? 'none' : '0 2px 4px rgba(0,0,0,0.05)'
          },
          selected: false,
          data: { ...item.data, selected: false }
        };
      })
    );
  };

  const clickEdge = (event, node) => {
    setNodes(old =>
      old.map(item => {
        return {
          ...item,
          style: {
            backgroundColor: theme.palette.background.paper,
            borderRadius: item.type === 'start' ? 8 : 12,
            border: `2px solid #FF9800`, // Reset to Orange
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
          }
        };
      })
    );
  };

  const updateNode = dataAlter => {
    setNodes(old =>
      old.map(itemNode => {
        if (itemNode.id === dataAlter.id) {
          return dataAlter;
        }
        return itemNode;
      })
    );
    setHasChanges(true); // Marcar que hubo cambios

    // Fechar todos os modais
    setModalAddText(null);
    setModalAddInterval(null);
    setModalAddTicketStatus(null);
    setModalAddMenu(null);
    setModalAddImg(null);
    setModalAddDoc(null);
    setModalAddOpenAI(null);
    setModalAddAudio(null);
    setModalAddRandomizer(null);
    setModalAddVideo(null);
    setModalAddGemini(null);
    setModalAddSingleBlock(null);
    setModalAddTicket(null);
    setModalAddRemoveTag(null);
    setModalAddTag(null);
    setModalAddSwitchFlow(null);
    setModalAddAttendant(null);
    setModalAddInput(null);
    setModalAddPoll(null);
    setModalAddConditionCompare(null);
    setModalAddJump(null);
    setModalAddScheduling(null);
    setModalAddButtonInteractive(null);
    setModalAddListInteractive(null);
    setModalAddForm(null);
    setModalAddNotifier(null);
    setModalAddSaveContact(null);
    setModalKnowledgeOpen(false);
  };

  // Handler para categoria expand/collapse (Comportamiento de Acordeón)
  const handleCategoryToggle = (categoryName) => {
    setExpandedCategories(prev =>
      prev.includes(categoryName)
        ? []
        : [categoryName]
    );
  };



  const handleSaveJump = (data) => {
    // [ANTIGRAVITY] Fix: Retrieve position from Ref
    let posX, posY;

    const storedPos = localStorage.getItem('pendingJumpPos');
    if (storedPos) {
      const parsed = JSON.parse(storedPos);
      posX = parsed.x;
      posY = parsed.y;
      localStorage.removeItem('pendingJumpPos');
    } else if (data && data.position) {
      // 2. Check returned payload
      posX = data.position.x;
      posY = data.position.y;
    } else if (dataNode && dataNode.position) {
      // 3. Fallback state
      posX = dataNode.position.x;
      posY = dataNode.position.y;
    } else {
      // 4. Default end of flow
      const lastNode = nodes[nodes.length - 1];
      posY = lastNode ? lastNode.position.y : 100;
      posX = lastNode ? lastNode.position.x + (lastNode.width || 200) + 40 : 250;
    }

    const newNode = {
      id: geraStringAleatoria(30),
      type: 'jump',
      position: { x: posX, y: posY },
      data: {
        destinationNodeId: data.destinationNodeId,
        destinationNodeName: data.destinationNodeName,
        name: data.name,
        ...data
      }
    };

    setNodes((nds) => nds.concat(newNode));
    setHasChanges(true); // [ANTIGRAVITY] Fix: Mark changes
    setModalAddJump(null);
    setDataNode(null); // Clear temp position
  }

  const handleUpdateJump = (data) => {
    setNodes((nds) =>
      nds.map((node) => {
        if (node.id === data.id) {
          return {
            ...node,
            data: data.data,
          };
        }
        return node;
      })
    );
    setModalAddJump(null);
  };

  // Componente do Sidebar
  // [ANTIGRAVITY] Moved Handlers Here (After addNode definition)

  const onDragStart = useCallback((event, nodeType) => {
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.effectAllowed = 'move';
  }, []);

  const onDragOver = useCallback((event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  }, []);

  // [ANTIGRAVITY] Handler to save viewport when user moves or zooms
  const onMoveEnd = useCallback((event, viewport) => {
    const flowId = id;
    if (flowId) {
      const viewportKey = `flow-viewport-${flowId}`;
      localStorage.setItem(viewportKey, JSON.stringify(viewport));
    }
  }, [id]);

  // [ANTIGRAVITY] Restore viewport from localStorage when flow loads
  useEffect(() => {
    const flowId = id;
    if (flowId && reactFlowInstance) {
      const viewportKey = `flow-viewport-${flowId}`;
      const savedViewport = localStorage.getItem(viewportKey);
      if (savedViewport) {
        try {
          const parsed = JSON.parse(savedViewport);
          reactFlowInstance.setViewport(parsed);
        } catch (e) {
          console.error('[FlowBuilder] Error parsing saved viewport:', e);
        }
      }
    }
  }, [id, reactFlowInstance]);

  // [ANTIGRAVITY] Manual zoom handling for Ctrl+Scroll
  useEffect(() => {
    const wrapper = reactFlowWrapper.current;
    if (!wrapper) return;

    const handleWheel = (event) => {
      if (event.ctrlKey && reactFlowInstance) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const currentZoom = reactFlowInstance.getZoom();
        const delta = event.deltaY;
        const zoomFactor = 0.001;
        const zoomChange = delta * zoomFactor;
        let newZoom = currentZoom - zoomChange;
        newZoom = Math.max(0.1, Math.min(4, newZoom));
        reactFlowInstance.zoomTo(newZoom);
      }
    };

    wrapper.addEventListener('wheel', handleWheel, { passive: false, capture: true });
    // document.addEventListener('wheel', handleWheel, { passive: false, capture: true }); // Removed document listener to avoid global interference

    return () => {
      wrapper.removeEventListener('wheel', handleWheel, { capture: true });
      // document.removeEventListener('wheel', handleWheel, { capture: true });
    };
  }, [reactFlowInstance]);

  const onDrop = useCallback(
    (event) => {
      event.preventDefault();
      const type = event.dataTransfer.getData('application/reactflow');
      if (typeof type === 'undefined' || !type) return;

      const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
      const position = reactFlowInstance.project({
        x: event.clientX - reactFlowBounds.left,
        y: event.clientY - reactFlowBounds.top,
      });

      // [ANTIGRAVITY] Fix: Handle Jump Drop DIRECTLY to avoid addNode issues
      if (type === 'jump') {
        setHasChanges(true); // Mark changes
        setNodes((nds) => nds.concat({
          id: geraStringAleatoria(30),
          type: 'jump',
          position,
          data: { name: "", destinationNodeId: "" }
        }));
        return;
      }

      // Eliminada validación de nodo IA único para permitir configuraciones complejas
      if (type === 'openai') {
        // Permitir múltiples nodos
      }

      // Call addNode (now fully initialized) for other types
      addNode(type, { position });
    },
    [reactFlowInstance, addNode, setNodes] // Added setNodes dependency
  );

  const sidebarContentJSX = React.useMemo(() => (
    <div className={classes.sidebarContent}>
      {/* [ANTIGRAVITY] AI Tools Section - REMOVED */}

      {nodeCategories.map((category) => (
        <div key={category.name}>
          {sidebarOpen ? (
            // Modo expandido
            <>
              <div className={classes.categoryHeader}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  onClick={() => handleCategoryToggle(category.name)}
                  style={{ cursor: "pointer" }}
                >
                  <Box display="flex" alignItems="center">
                    <Box mr={2} style={{ color: typeof category.color === 'function' ? category.color(theme) : category.color, display: "flex" }}>
                      {category.icon}
                    </Box>
                    <Typography variant="body2">
                      {category.name}
                    </Typography>
                  </Box>
                  {expandedCategories.includes(category.name) ? <ExpandLess /> : <ExpandMore />}
                </Box>
              </div>

              <Collapse in={expandedCategories.includes(category.name)}>
                <List dense>
                  {category.nodes.map((node) => (
                    <ListItem key={node.type}>
                      <Button
                        fullWidth
                        variant="text"
                        className={classes.nodeButton}
                        // onClick={() => clickActions(node.type)} // Disabled: Force Drag-and-Drop
                        draggable={true}
                        onDragStart={(event) => onDragStart(event, node.type)}
                        startIcon={
                          <Box sx={{ color: typeof category.color === 'function' ? category.color(theme) : category.color }}>
                            {node.icon}
                          </Box>
                        }
                      >
                        <Box textAlign="left" width="100%">
                          <Typography variant="body2">
                            {node.name}
                          </Typography>
                          <Typography variant="caption" color="textSecondary">
                            {node.description}
                          </Typography>
                        </Box>
                      </Button>
                    </ListItem>
                  ))}
                  {category.name === i18n.t("flowBuilder.editor.categories.basics") && sidebarOpen && (
                    <ListItem>
                      <Box display="flex" flexDirection="column" width="100%">
                        <Box p={1.5} mt={1} width="100%" bgcolor={theme.palette.type === 'dark' ? '#222' : '#f5f5f5'} borderRadius={8} border={`1px solid ${theme.palette.type === 'dark' ? '#333' : '#e0e0e0'}`}>
                          <Typography variant="body2" style={{ fontWeight: 600, display: 'block', marginBottom: 8, color: theme.palette.type === 'dark' ? '#ccc' : '#666' }}>
                            <Info style={{ fontSize: 16, verticalAlign: 'middle', marginRight: 4 }} /> {i18n.t("flowBuilder.editor.sidebar.variablesTitle", "Variables Disponibles")}
                          </Typography>
                          <Typography variant="body2" color="textSecondary" style={{ display: 'block', lineHeight: 1.6, fontSize: '0.8rem' }}>
                            <strong style={{color: '#2979FF'}}>{"{{triggerMessage}}"}</strong> - {i18n.t("flowBuilder.editor.sidebar.variables.triggerMessage", "Mensaje Entrante")}<br/>
                            <strong style={{color: '#2979FF'}}>{"{{name}}"}</strong> - {i18n.t("flowBuilder.editor.sidebar.variables.name", "Nombre completo")}<br/>
                            <strong style={{color: '#2979FF'}}>{"{{firstName}}"}</strong> - {i18n.t("flowBuilder.editor.sidebar.variables.firstName", "Primer nombre")}<br/>
                            <strong style={{color: '#2979FF'}}>{"{{ticket_id}}"}</strong> - {i18n.t("flowBuilder.editor.sidebar.variables.ticket", "N° de Ticket")}<br/>
                            <strong style={{color: '#2979FF'}}>{"{{date}}"}</strong> - {i18n.t("flowBuilder.editor.sidebar.variables.date", "Fecha actual")}<br/>
                            <strong style={{color: '#2979FF'}}>{"{{hour}}"}</strong> - {i18n.t("flowBuilder.editor.sidebar.variables.hour", "Hora actual")}<br/>
                            <strong style={{color: '#2979FF'}}>{"{{contact_id}}"}</strong> - {i18n.t("flowBuilder.editor.sidebar.variables.contactId", "ID Contacto")}<br/>
                            <strong style={{color: '#2979FF'}}>{"{{contact_number}}"}</strong> - {i18n.t("flowBuilder.editor.sidebar.variables.contactNumber", "Teléfono Contacto")}<br/>
                            <strong style={{color: '#2979FF'}}>{"{{agent_email}}"}</strong> - {i18n.t("flowBuilder.editor.sidebar.variables.agentEmail", "Email Agente")}
                          </Typography>
                        </Box>
                        <Box p={1.5} mt={1} width="100%" bgcolor={theme.palette.type === 'dark' ? '#222' : '#f5f5f5'} borderRadius={8} border={`1px solid ${theme.palette.type === 'dark' ? '#333' : '#e0e0e0'}`}>
                          <Typography variant="body2" style={{ fontWeight: 600, display: 'block', marginBottom: 8, color: theme.palette.type === 'dark' ? '#ccc' : '#666' }}>
                            <WhatsApp style={{ fontSize: 16, verticalAlign: 'middle', marginRight: 4 }} /> {i18n.t("flowBuilder.editor.sidebar.formatsTitle", "Formatos WhatsApp")}
                          </Typography>
                          <Typography variant="body2" color="textSecondary" style={{ display: 'block', lineHeight: 1.6, fontSize: '0.8rem' }}>
                            • <strong style={{color: '#2979FF'}}>{i18n.t("flowBuilder.editor.sidebar.formats.bold", "Negrita:")}</strong> <span style={{ backgroundColor: theme.palette.type === 'dark' ? '#444' : '#e0e0e0', padding: '2px 4px', borderRadius: '4px' }}>*{i18n.t("flowBuilder.editor.sidebar.formats.placeholder", "texto")}*</span><br/>
                            • <em style={{color: '#2979FF'}}>{i18n.t("flowBuilder.editor.sidebar.formats.italic", "Cursiva:")}</em> <span style={{ backgroundColor: theme.palette.type === 'dark' ? '#444' : '#e0e0e0', padding: '2px 4px', borderRadius: '4px' }}>_{i18n.t("flowBuilder.editor.sidebar.formats.placeholder", "texto")}_</span><br/>
                            • <span style={{ textDecoration: 'line-through', color: '#2979FF' }}>{i18n.t("flowBuilder.editor.sidebar.formats.strikethrough", "Tachado:")}</span> <span style={{ backgroundColor: theme.palette.type === 'dark' ? '#444' : '#e0e0e0', padding: '2px 4px', borderRadius: '4px' }}>~{i18n.t("flowBuilder.editor.sidebar.formats.placeholder", "texto")}~</span><br/>
                            • <span style={{color: '#2979FF'}}>{i18n.t("flowBuilder.editor.sidebar.formats.monospace", "Monoespaciado:")}</span> <span style={{ backgroundColor: theme.palette.type === 'dark' ? '#444' : '#e0e0e0', padding: '2px 4px', borderRadius: '4px' }}>```{i18n.t("flowBuilder.editor.sidebar.formats.placeholder", "texto")}```</span>
                          </Typography>
                        </Box>
                      </Box>
                    </ListItem>
                  )}
                </List>
              </Collapse>
            </>
          ) : (
            // Modo colapsado - só ícones
            <div>
              {category.nodes.map((node) => (
                <Tooltip key={node.type} title={node.name} placement="right">
                  <IconButton
                    className={classes.collapsedNodeButton}
                    // onClick={() => clickActions(node.type)} // Disabled: Force Drag-and-Drop
                    draggable={true}
                    onDragStart={(event) => onDragStart(event, node.type)}
                    style={{ color: typeof category.color === 'function' ? category.color(theme) : category.color }}
                  >
                    {node.icon}
                  </IconButton>
                </Tooltip>
              ))}
            </div>
          )}
        </div>
      ))}
    </div >
  ), [classes, theme, sidebarOpen, expandedCategories, nodeCategories, onDragStart]);

  // Componente do Bottom Sheet
  const bottomSheetJSX = React.useMemo(() => (
    <Slide direction="up" in={bottomSheetOpen} mountOnEnter unmountOnExit>
      <div className={classes.bottomSheet}>
        <div
          className={classes.bottomSheetHandle}
          onClick={() => setBottomSheetOpen(false)}
        />

        <div className={classes.bottomSheetHeader}>
          <Typography variant="h6">{i18n.t("flowBuilder.editor.sidebar.addNodes")}</Typography>
          <IconButton onClick={() => setBottomSheetOpen(false)} size="small">
            <CloseIcon />
          </IconButton>
        </div>

        <div className={classes.bottomSheetContent}>
          <Grid container spacing={2}>
            {nodeCategories.map((category) => (
              <Grid item xs={6} key={category.name}>
                <Paper elevation={1} className={classes.categoryCard} style={{ padding: 8 }}>
                  <Typography
                    variant="subtitle2"
                    className={classes.categoryTitle}
                    style={{ color: typeof category.color === 'function' ? category.color(theme) : category.color, marginBottom: 8 }}
                  >
                    {category.name}
                  </Typography>
                  {category.nodes.map((node) => (
                    <Button
                      key={node.type}
                      fullWidth
                      variant="outlined"
                      // onClick={() => clickActions(node.type)} // Disabled: Force Drag-and-Drop
                      startIcon={
                        <Box sx={{ color: typeof category.color === 'function' ? category.color(theme) : category.color }}>
                          {node.icon}
                        </Box>
                      }
                      className={classes.categoryNodeBtn}
                      size="small"
                    >
                      {node.name}
                    </Button>
                  ))}
                </Paper>
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
    </Slide>
  ), [classes, theme, bottomSheetOpen, nodeCategories, onDragStart]);

  if (loading) {
    return (
      <div className={classes.root}>
        <div className={classes.header} style={{ display: 'flex', alignItems: 'center', padding: '16px 24px' }}>
          <Title>{i18n.t("flowBuilder.editor.header.title")}</Title>
        </div>
        <div className={classes.loadingContainer}>
          <CircularProgress style={{ color: theme.palette.primary.main }} />
        </div>
      </div>
    );
  }

  return (

    <div className={classes.root}>
      <AIKnowledgeModal
        open={modalKnowledgeOpen}
        onClose={() => setModalKnowledgeOpen(false)}
        flowId={id}
      />

      {/* Header */}
      <div className={classes.header} style={{ display: 'flex', alignItems: 'center', padding: '16px 24px' }}>
          <Title>
            {i18n.t("flowBuilder.editor.header.title")}
            {flowName ? ` - ${flowName}` : ""}
          </Title>
      </div>

      {/* Guard de Navegação Personalizado */}
      <ConfirmationModal
        title={`${(user && user.company && user.company.name) || "BotMix"} - Flow Builder`}
        open={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onConfirm={handleConfirmExit}
      >
        {i18n.t("flowBuilder.editor.messages.unsavedChanges") || "Você tem alterações não salvas. Tem certeza de que deseja sair?"}
      </ConfirmationModal>

      {/* Content */}
      <div className={classes.content}>
        {/* Sidebar Desktop */}
        {!isMobile && (
          <div className={classes.sidebar}>
            <div className={classes.sidebarHeader}>
              {sidebarOpen && (
                <Typography variant="subtitle1" fontWeight="bold">
                  {i18n.t("flowBuilder.editor.sidebar.addNodes")}
                </Typography>
              )}
              <IconButton
                onClick={() => setSidebarOpen(!sidebarOpen)}
                size="small"
              >
                {sidebarOpen ? <ChevronLeft /> : <ChevronRight />}
              </IconButton>
            </div>
            {sidebarContentJSX}
          </div>
        )}

        {/* Flow Container */}
        <div className={classes.flowContainer} ref={reactFlowWrapper}>
          <ReactFlow
            nodes={nodes}
            edges={edges}
            onDrop={onDrop}
            onDragOver={onDragOver}
            deleteKeyCode={["Backspace", "Delete"]}
            onNodesChange={(changes) => setNodes((nds) => applyNodeChanges(changes, nds))}
            onEdgesChange={(changes) => setEdges((eds) => applyEdgeChanges(changes, eds))}
            onNodeDragStop={() => setHasChanges(true)}
            onNodeDoubleClick={doubleClick}
            onNodeClick={clickNode}
            onEdgeClick={clickEdge}
            onConnect={onConnect}
            onEdgeUpdate={onEdgeUpdate}
            onNodeDragStart={onNodeDragStart}
            onNodesDelete={onNodesDelete}
            onEdgesDelete={onEdgesDelete}
            onMoveEnd={onMoveEnd}
            nodeTypes={nodeTypes}
            minZoom={0.1}
            maxZoom={4}
            zoomOnScroll={true}
            zoomOnPinch={true}
            zoomOnDoubleClick={false}
            panOnScroll={false}
            panOnScrollSpeed={0.5}
            connectionLineStyle={connectionLineStyle}
            connectionLineType={ConnectionLineType.SmoothStep}
            style={{
              //backgroundImage: `url(${ imgBackground })`,
              //backgroundSize: "cover"
              backgroundColor: "#F8F9FA"
            }}
            edgeTypes={edgeTypes}
            variant={"cross"}
            defaultEdgeOptions={{
              style: { stroke: "#FF9800", strokeWidth: 2 },
              animated: false,
              type: 'buttonedge'
            }}
          >
            <Controls
              showZoom={true}
              showFitView={true}
              showInteractive={true}
              style={{
                display: 'flex',
                zIndex: 10,
                bottom: '20px',
                left: '20px'
              }}
            />
            <Background variant="dots" gap={12} size={1} />
          </ReactFlow>

          <Tooltip title={i18n.t("flowBuilder.editor.quickActions.save") || "Guardar Flujo"}>
            <Fab
              onClick={saveFlow}
              style={{
                position: 'absolute',
                top: 20,
                right: 16,
                zIndex: 1400,
                backgroundColor: '#10b981', // green for save
                color: '#fff',
                boxShadow: '0 3px 10px rgba(16,185,129,0.35)',
                transition: 'all 0.2s ease',
                cursor: 'pointer'
              }}
              onMouseOver={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; e.currentTarget.style.backgroundColor = '#059669'; }}
              onMouseOut={(e) => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.backgroundColor = '#10b981'; }}
            >
              <SaveIcon />
            </Fab>
          </Tooltip>

          {!isMobile && (
            <Tooltip title={simulatorOpen ? "Cerrar Simulador" : "Probar Agente IA"}>
              <Fab
                onClick={() => setSimulatorOpen(s => !s)}
                style={{
                  position: 'absolute',
                  top: 80,
                  right: 16,
                  zIndex: 1400,
                  backgroundColor: '#7c3aed',
                  color: '#fff',
                  boxShadow: '0 3px 10px rgba(124,58,237,0.35)',
                  transition: 'all 0.2s ease',
                  cursor: 'pointer'
                }}
                onMouseOver={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; e.currentTarget.style.backgroundColor = '#6d28d9'; }}
                onMouseOut={(e) => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.backgroundColor = '#7c3aed'; }}
                id="ai-simulator-toggle-btn"
              >
                <TbRobot size={24} />
              </Fab>
            </Tooltip>
          )}

        </div>

        {/* [ANTIGRAVITY] Plan 899 — AI Simulator Panel (right side, all flows) */}
        {!isMobile && simulatorOpen && (
          <AiSimulatorPanel
            flowId={id}
            aiNodeData={simulatorAiNodeData}
            onClose={() => setSimulatorOpen(false)}
          />
        )}
      </div>

      {/* Mobile Controls */}
      {isMobile && <MobileControls />}

      

      



      {/* Bottom Sheet Mobile */}
      {isMobile && bottomSheetJSX}

      {/* FAB Adicionar - só em mobile */}
      {isMobile && (
        <Fab
          color="secondary"
          className={classes.addFab}
          onClick={() => setBottomSheetOpen(true)}
        >
          <AddIcon />
        </Fab>
      )}

      {/* Click Away Listener para Bottom Sheet */}
      {isMobile && bottomSheetOpen && (
        <ClickAwayListener onClickAway={() => setBottomSheetOpen(false)}>
          <div />
        </ClickAwayListener>
      )}

      {/* TODOS OS MODAIS COMPLETOS - mantidos iguais */}
      {Boolean(modalAddText) && (
      <FlowBuilderAddTextModal
        open={modalAddText}
        onSave={textAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddText(null)}
      />
      )}
      {Boolean(modalAddInterval) && (
      <FlowBuilderIntervalModal
        open={modalAddInterval}
        onSave={intervalAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddInterval(null)}
      />
      )}
      {Boolean(modalAddTicketStatus) && (
      <ModalAddTicketStatus
        open={modalAddTicketStatus}
        onSave={ticketStatusAdd}
        node={dataNode}
        onUpdate={updateNode}
        onClose={() => {
          setModalAddTicketStatus(null);
        }}
      />
      )}
      {Boolean(modalAddMenu) && (
      <FlowBuilderMenuModal
        open={modalAddMenu}
        onSave={menuAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddMenu(null)}
      />
      )}
      {Boolean(modalAddImg) && (
      <FlowBuilderAddImgModal
        open={modalAddImg}
        onSave={imgAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddImg(null)}
      />
      )}
      {Boolean(modalAddDoc) && (
      <FlowBuilderAddDocModal
        open={modalAddDoc}
        onSave={docAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddDoc(null)}
      />
      )}
      {Boolean(modalAddAudio) && (
      <FlowBuilderAddAudioModal
        open={modalAddAudio}
        onSave={audioAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddAudio(null)}
      />
      )}
      {Boolean(modalAddRandomizer) && (
      <FlowBuilderRandomizerModal
        open={modalAddRandomizer}
        onSave={randomizerAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddRandomizer(null)}
      />
      )}
      {Boolean(modalAddVideo) && (
      <FlowBuilderAddVideoModal
        open={modalAddVideo}
        onSave={videoAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddVideo(null)}
      />
      )}
      {Boolean(modalAddSingleBlock) && (
      <FlowBuilderSingleBlockModal
        open={modalAddSingleBlock}
        onSave={singleBlockAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddSingleBlock(null)}
      />
      )}
      {Boolean(modalAddTicket) && (
      <FlowBuilderTicketModal
        open={modalAddTicket}
        onSave={ticketAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddTicket(null)}
      />
      )}
              {Boolean(modalAddRemarketing) && (
      <FlowBuilderRemarketingModal
          open={modalAddRemarketing}
          data={dataNode}
          onSave={remarketingAdd}
          onUpdate={updateNode}
          close={() => setModalAddRemarketing(null)}
        />
      )}
        {Boolean(modalAddOpenAI) && (
      <FlowBuilderOpenAIModal
        open={modalAddOpenAI}
        onSave={openaiAdd}
        data={dataNode}
        onUpdate={updateNode}
        flowId={id}
        close={() => setModalAddOpenAI(null)}
      />
      )}
      {/* {Boolean(modalAddGemini) && (
      <FlowBuilderGeminiModal
        open={modalAddGemini}
        onSave={geminiAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddGemini}
      />
      )} */}
      {Boolean(modalAddTag) && (
      <FlowBuilderAddTagModal
        open={modalAddTag}
        onSave={tagAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddTag(null)}
      />
      )}
      {Boolean(modalAddKanban) && (
      <FlowBuilderAddKanbanModal
        open={modalAddKanban}
        onSave={kanbanAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddKanban(null)}
        whatsappIds={whatsappIds}
        flowKanbanId={flowKanbanId}
        flowBrandId={flowBrandId}
      />
      )}
      {Boolean(modalAddRemoveTag) && (
      <FlowBuilderRemoveTagModal
        open={modalAddRemoveTag}
        onSave={removeTagAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddRemoveTag(null)}
      />
      )}
      {Boolean(modalAddSwitchFlow) && (
      <FlowBuilderAddSwitchFlowModal
        open={modalAddSwitchFlow}
        onSave={switchFlowAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddSwitchFlow(null)}
      />
      )}
      {Boolean(modalAddAttendant) && (
      <FlowBuilderAddAttendantModal
        open={modalAddAttendant}
        onSave={attendantAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddAttendant(null)}
      />
      )}
      {modalAddInput && (
        <FlowBuilderInputModal
          open={modalAddInput}
          onSave={inputAdd}
          data={dataNode}
          onUpdate={updateNode}
          close={() => setModalAddInput(false)}
        />
      )}
      {modalAddPoll && (
        <FlowBuilderPollModal
          open={modalAddPoll}
          onSave={pollAdd}
          data={dataNode}
          onUpdate={updateNode}
          close={() => setModalAddPoll(false)}
        />
      )}
      {modalAddConditionCompare && (
        <FlowBuilderConditionCompareModal
          open={modalAddConditionCompare}
          onSave={conditionCompareAdd}
          data={dataNode}
          onUpdate={updateNode}
          nodes={nodes}
          close={() => setModalAddConditionCompare(false)}
        />
      )}
      {Boolean(modalAddJump) && (
      <FlowBuilderAddJumpModal
        open={modalAddJump}
        onSave={handleSaveJump}
        onUpdate={handleUpdateJump}
        data={dataNode}
        close={() => setModalAddJump(null)}
        nodes={nodes}
      />
      )}

      {Boolean(modalAddPaymentValidation) && (
      <FlowBuilderAddPaymentValidationModal
        open={modalAddPaymentValidation}
        onSave={paymentValidationAdd}
        onUpdate={updateNode}
        data={dataNode}
        close={() => setModalAddPaymentValidation(null)}
      />
      )}

      {Boolean(modalAddScheduling) && (
      <FlowBuilderAddSchedulingModal
        open={modalAddScheduling}
        onSave={schedulingAdd}
        onUpdate={updateNode}
        data={dataNode}
        close={() => setModalAddScheduling(null)}
      />
      )}

      {Boolean(modalAddForm === "edit") && (
      <FlowBuilderAddFormModal
        open={modalAddForm === "edit"}
        onSave={formAdd}
        onUpdate={updateNode}
        data={dataNode}
        close={() => setModalAddForm(null)}
      />
      )}

      {Boolean(modalAddNotifier === "edit") && (
      <FlowBuilderAddNotifierModal
        open={modalAddNotifier === "edit"}
        onSave={notifierAdd}
        onUpdate={updateNode}
        data={dataNode}
        close={() => setModalAddNotifier(null)}
      />
      )}

      {Boolean(modalAddRetargeting === "edit") && (
      <FlowBuilderAddRetargetingModal
        open={modalAddRetargeting === "edit"}
        onSave={(data) => {}} 
        onUpdate={updateNode}
        data={dataNode}
        close={() => setModalAddRetargeting(null)}
      />
      )}

      {Boolean(modalAddSaveContact === "edit") && (
      <FlowBuilderSaveContactModal
        open={modalAddSaveContact === "edit"}
        onSave={saveContactAdd}
        onUpdate={updateNode}
        data={dataNode}
        close={() => setModalAddSaveContact(null)}
      />
      )}

      {/* ── [Plan 904] Modal Edición: Botones Interactivos META API ── */}
      {modalAddButtonInteractive && dataNode && (
        <FlowBuilderInteractiveButtonModal
          node={dataNode}
          onClose={() => setModalAddButtonInteractive(null)}
          onSave={(updatedData) => {
            updateNode({ ...dataNode, data: { ...dataNode.data, ...updatedData } });
            setModalAddButtonInteractive(null);
          }}
        />
      )}

      {/* ── Modal Edición: Carrusel Interactivo META API ── */}
      {modalAddCarouselInteractive && dataNode && (
        <FlowBuilderCarouselModal
          node={dataNode}
          onClose={() => setModalAddCarouselInteractive(null)}
          onSave={(updatedData) => {
            updateNode({ ...dataNode, data: { ...dataNode.data, ...updatedData } });
            setModalAddCarouselInteractive(null);
          }}
        />
      )}

      {/* ── [Plan 904] Modal Edición: Lista Interactiva META API ── */}
      {modalAddListInteractive && dataNode && (
        <FlowBuilderInteractiveListModal
          node={dataNode}
          onClose={() => setModalAddListInteractive(null)}
          onSave={(updatedData) => {
            updateNode({ ...dataNode, data: { ...dataNode.data, ...updatedData } });
            setModalAddListInteractive(null);
          }}
        />
      )}

      <style>{`
  /* FORCE OVERRIDE FOR INPUT NODES TO FIX DOUBLE BORDER */
  .react - flow__node - input,
        .react - flow__node - inputNode,
        .react - flow__node - question {
  border: none!important;
  background: transparent!important;
  box - shadow: none!important;
  padding: 0!important;
  overflow: visible!important;
}
        .react - flow__node - input.selected,
        .react - flow__node - inputNode.selected,
        .react - flow__node - question.selected {
  border: none!important;
  box - shadow: none!important;
  background: transparent!important;
}

  /* FORCE REACTFLOW CONTROLS VISIBILITY */
  .react-flow__controls {
    display: flex !important;
    flex-direction: column !important;
    position: absolute !important;
    bottom: 80px !important; /* Raised up from 20px to 80px */
    left: 20px !important;
    z-index: 1000 !important;
    background: white !important;
    border: 1px solid #ddd !important;
    border-radius: 4px !important;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1) !important;
  }
  
  .react-flow__controls button {
    display: block !important;
    width: 32px !important;
    height: 32px !important;
    background: white !important;
    border: none !important;
    border-bottom: 1px solid #eee !important;
    cursor: pointer !important;
    font-size: 18px !important;
  }
  
  .react-flow__controls button:hover {
    background: #f5f5f5 !important;
  }
  
  .react-flow__controls button:last-child {
    display: none !important; /* Hide lock button that doesn't work */
  }
}
`}</style>
    </div >
  );
};

export const FlowBuilderConfig = () => {
  const { id } = useParams();

  return (
    <ReactFlowProvider>
      <FlowBuilder id={id} />
    </ReactFlowProvider>
  );
};
